import { uploadImageToOverlay } from '../directives/overlay-image';

let module = angular.module('app.services.overlays', []);

const PAGE_SIZE = 20;

module.service('Overlays', function ($q, $http) {
  'ngInject';

  this.loadOverlaysForPage = (p) => {
    return $http
      .get(`${API_ROOT}/account/uploads`, {
        params: {
          'filter.slot': 'overlay',
          p: Math.max(0, p - 1),
          l: PAGE_SIZE,
          s: '-created_at',
        },
      })
      .then((response) => {
        var pagination = JSON.parse(response.headers('x-pagination'));
        return {
          uploads: response.data,
          pagination: {
            current: p,
            total: pagination.total,
            resultMin: PAGE_SIZE * (p - 1) + 1,
            resultMax: PAGE_SIZE * (p - 1) + response.data.length,
          },
        };
      });
  };

  this.preloadUploadImage = (upload) => {
    return $q((resolve, reject) => {
      // this needs to be in the initialization logic when first dragging onto canvas
      $('<img/>') // Make in memory copy of image to avoid css issues
        .attr('src', upload.view_url)
        .load(function () {
          const { width, height } = this; // get actual image dimensions from <img>
          resolve({ width, height });
        })
        .error(function (err) {
          reject(err);
        });
    });
  };

  this.prepareUploadForOverlay = (upload) => {
    return this.preloadUploadImage(upload).then((dims) => {
      return uploadImageToOverlay(upload, dims.width, dims.height);
    });
  };
});

export default module;



// WEBPACK FOOTER //
// ./app/services/overlays.js